import React from 'react';
import { cn } from '../../../utils/cn';
import type { EnhancedFieldConfiguration } from '../../types';

interface LinkWrapperProps {
	children: React.ReactNode;
	isClickable: boolean;
	onClick?: (e: React.MouseEvent) => void;
	/** When provided, renders an anchor with this href instead of a button */
	href?: string | null;
	field: EnhancedFieldConfiguration;
	data: unknown;
	objects?: Array<{ objectTable: string; baseUrl?: string }>;
}

export function LinkWrapper({
	children,
	isClickable,
	onClick,
	href,
	field,
	data,
	objects,
}: LinkWrapperProps) {
	if (isClickable && onClick) {
		// Navigation links render as anchors for right-click/middle-click support
		if (href != null) {
			return (
				<a
					href={href}
					onClick={onClick}
					className={cn(
						'cursor-pointer hover:opacity-80 transition-opacity no-underline',
					)}
				>
					{children}
				</a>
			);
		}

		return (
			<button
				onClick={onClick}
				className={cn(
					'cursor-pointer hover:opacity-80 transition-opacity text-left',
				)}
				type="button"
			>
				{children}
			</button>
		);
	}

	return <>{children}</>;
}
